import {
  NoUserActionMessage,
  ServerErrorMessage,
} from "@sgwt-widget/components-base";
import {
  h,
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core";
import { find } from "lodash";
import { ApiBackedScComponent } from "../../common/components/ApiBackedScComponent";
import { DealListDateRange } from "../../common/components/DealListExport/DealListDateRange";
import { DealListEmail } from "../../common/components/DealListExport/DealListEmail";
import {
  SalesCreditDealExportAttribute,
  SalesCreditDealExportKpi,
} from "../../common/components/DealListExport/SalescreditExportColumns";
import { IStoredData } from "../../common/components/DealListExport/Types";
import { MakeBackgroundExportDataApiCall } from "../../common/generic/generic-api";
import {
  GenericFilterBuilder,
  HandleCsvCallErrors,
} from "../../common/generic/generic-helper";
import { UserActionOnAuthErrorMessage } from "../../common/generic/generic-message";
import { SCKpis } from "../../common/generic/generic-sc-domain";
import {
  IGenericColumns,
  IGenericCsvRequest,
  IGenericRequest,
} from "../../common/generic/generic-types";
import { ConvertFilter, areFiltersCompatible } from "../../common/salescredit/salescredit-filter-help";
import { SCProfileDictionary } from "../../common/salescredit/salescredit-profile-dictionary";
import { BuildSalesCreditFilters } from "../../common/salescredit/salescredit-search-criteria";
import {
  IExportColumn,
  IProps,
} from "../../common/salescredit/salescredit-types";
import { maxSelectedClients } from "../../common/utils/clientlistHelper";
import { getMailBody } from "../utils/helper";

interface IState {
  excludeZero?: boolean;
  fromDate: string;
  toDate: string;
  attrsSelected: string;
  kpisSelected: string;
  filters: string;
  visibleAttributes: any[];
  visibleKpis: any[];
  level: string;
  date: string;
  top?: number;
  dataLevel: string;
  sort: string;
  specificFromDate: string;
  specificToDate: string;
  spinnerClass: string;
  btnText: string;
  statusText?: string;
}

const displayNone = "display: none";
const scnotzero = ",sc_sc:noteq:0,sc_sc:noteq:";

export class SalesCreditExportDealListClass extends ApiBackedScComponent<
  IProps & IWidgetConfigurationProps,
  IState
> {
  private readonly currentDate = new Date();
  private readonly attributes: IExportColumn[];
  private readonly kpis: IExportColumn[];
  private readonly mailTo: string;
  private readonly subject: string;
  private readonly bodyMessage: string;
  private readonly key: string;
  private readonly defaultData: IStoredData;

  public constructor() {
    super();

    this.key = "salescredit_export_deal_data";
    const storedData = localStorage.getItem(this.key);
    if (storedData === null || storedData === undefined) {
      this.defaultData = {
        excludeZero: true,
        level: SCKpis.SC_YTD,
        top: undefined,
      };
    } else {
      this.defaultData = JSON.parse(storedData) as IStoredData;
    }

    this.setState({
      btnText: "Export ",
      dataLevel: "ready",
      excludeZero: this.defaultData.excludeZero,
      fromDate: this.currentDate.toISOString().slice(0, 4) + "-01-01",
      level: this.defaultData.level,
      sort: "-sc_sc",
      specificFromDate: this.currentDate.toISOString().slice(0, 4) + "-01-01",
      specificToDate: this.currentDate.toISOString().slice(0, 10),
      spinnerClass: "",
      toDate: this.currentDate.toISOString().slice(0, 10),
      top: this.defaultData.top,
    });

    this.attributes = SalesCreditDealExportAttribute();
    this.kpis = SalesCreditDealExportKpi();
    this.downloadCsv = this.downloadCsv.bind(this);
    this.setState({ date: this.state.fromDate + ":" + this.state.toDate });
    this.mailTo = "PAR-FIND-SalesCreditManagement@sgcib.com";
    this.subject = "Mark sales Dashboard – Report issue";
    this.bodyMessage = getMailBody();
  }

  protected renderWithDataReady(): JSX.Element {
    return (
      <div class="container" style="width: 100%; height: 100%">
        <div class="row">
          <div class="container col-12" style="width: 100%">
            <div class="row" style="margin-left: 1px">
              <div class="col-md-2" style="text-align: right">
                <b>Time Period</b>
              </div>
              <div class="col-md-3">
                <input
                  type="radio"
                  name="timePeriod"
                  checked={this.state.level === SCKpis.SC_YTD}
                  onClick={this.timePeriodClicked.bind(this, SCKpis.SC_YTD)}
                />{" "}
                Year-To-Date
              </div>
              <div class="col-md-2">
                <input
                  type="radio"
                  name="timePeriod"
                  checked={this.state.level === SCKpis.SC_D_1}
                  onClick={this.timePeriodClicked.bind(this, SCKpis.SC_D_1)}
                  style="margin-left: 15px"
                />{" "}
                Last Day
              </div>
              <div class="col-md-3">
                <input
                  type="radio"
                  name="timePeriod"
                  checked={this.state.level === SCKpis.SC_MTD}
                  onClick={this.timePeriodClicked.bind(this, SCKpis.SC_MTD)}
                  style="margin-left: 15px"
                />{" "}
                Month-To-Date
              </div>
            </div>
            <br />
            <div class="row" style="margin-left: 1px">
              <div
                class="col-md-3 col-md-offset-1"
                style="text-align: right;padding-right: 53px;"
              >
                <input
                  type="radio"
                  name="timePeriod"
                  checked={this.state.level === "specific"}
                  onClick={this.timePeriodClicked.bind(this, "specific")}
                />{" "}
                Specific Date Range
              </div>
              <div class="col-md-8">
                <DealListDateRange
                  onChangeFromDate={this.onChangeFromDate}
                  onChangeToDate={this.onChangeToDate}
                />
              </div>
            </div>
            <div class="row" style="margin-left: 1px">
              <div class="col-md-2" style="text-align: right">
                <b> Nb of rows </b>
              </div>
              <div class="col-md-3">
                <input
                  type="radio"
                  name="rows"
                  checked={this.state.top === undefined}
                  onClick={this.rowNbrClicked.bind(this, undefined)}
                />{" "}
                All Data(up to 200000 rows)
              </div>
              <div class="col-md-2">
                <input
                  type="radio"
                  name="rows"
                  checked={this.state.top === 100}
                  onClick={this.rowNbrClicked.bind(this, 100)}
                  style="margin-left: 15px"
                />{" "}
                Top 100
              </div>
              <div class="col-md-3">
                <input
                  type="radio"
                  name="rows"
                  checked={this.state.top === 10}
                  onClick={this.rowNbrClicked.bind(this, 10)}
                  style="margin-left: 15px"
                />{" "}
                Top 10
              </div>
            </div>
            <div class="checkbox row" style="margin-top: 1px;margin-left: 2px">
              <div class="col-md-offset-2 col-md-10">
                <label for="chkIncludeZero">
                  <input
                    type="checkbox"
                    id="chkIncludeZero"
                    checked={this.state.excludeZero}
                    onClick={() => this.onClickExcludeZero()}
                  />
                  <span>Hide deals with Sales Credit equals to 0</span>
                </label>
              </div>
            </div>
            <div class="row" style="margin-left: 1px">
              <div class="col-md-2" style="text-align: right">
                <b>Select filter(s) </b>
              </div>
              <div class="col-md-10">
                Please use board filters or local filters
              </div>
            </div>
            <br />
            <div class="row" style="margin-left: 1px">
              <div class="col-md-2" style="text-align: right">
                <b>Select Columns </b>
              </div>
              <div class="col-md-10">
                Please use 
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAH3SURBVEhLxZZLLwNRFMf/d1qdvvQhIqULNlZsPEITlhIfwlosiUisrKx8BEufwJqNiE9gKyylJKWtPlX1Omd6OzpaOmqmfslk5pzF3P8595xzr5BS4ieKVchaHag3gAY9dvBowJAHiIUglMuCEE13OitnvxWQK0NWa8r4A14SMjpsFdImIEVarZRrkA85ZxZn6u8A/y9fgRlpW9ArFgGc7peyMhym8grkKavKbDFtCuDISYCrVCirBQpSmcyZKcCtyL9SsgaZNgRwwRnmgMiWQH1lkDC6gItEObqSuQHuisqwQdgLTCboPaYcnaTH42KCuiAuChXZc++vT4CNa2XYYDUOHKwDySXl6CQX0rFVesWpeCpIY9AMmAYNqvO3d2xqPOH+AV53md4pQftguwAzV8D+hTK6MBUFtteAyIxy/AxNBhx2TMIBwvN4WDzmpbR7yDgJHQc1yv2x5v2nHKh1heajnu2HzDkwuwvM7wHPl8r5C1rramF/9zO7F3oS2FsEdhboZzR0fkskKHR+G5PQqbPfLvoQMBIW3IFHxk7Egv1loV/inzelW7MEI0H14TIhv/pocmMKCPogqB5cJeCjxqeaa13JiHtLE3JBupWJAJVctHOrGxYBDGciEYPwk1on4Esp/y8aaC7eFj0zMfBrebuAdFbOfQAYaq66l2S4BgAAAABJRU5ErkJggg==" />{" "}
                (top right corner )
              </div>
            </div>
            <br />
            <div class="row" style="margin-left: 100px">
              <div class="col-md-1">
                <button
                  class="btn btn-primary"
                  onClick={() => this.downloadCsv()}
                >
                  {this.state.btnText}
                  <i class={this.state.spinnerClass} />
                </button>
              </div>
              <div class="col-md-2">
                <DealListEmail
                  mailTo={this.mailTo}
                  subject={this.subject}
                  bodyMessage={this.bodyMessage}
                />
              </div>
            </div>
            <div
              style={
                this.state.dataLevel === "no-access-rights" ? "" : displayNone
              }
            >
              <UserActionOnAuthErrorMessage message={this.state.statusText} />
            </div>
            <div
              style={this.state.dataLevel === "server-error" ? "" : displayNone}
            >
              <ServerErrorMessage />
            </div>
            <div
              style={
                this.state.dataLevel === "client-request-error"
                  ? ""
                  : displayNone
              }
            >
              <NoUserActionMessage message="Client Request Error - Possible Timeout" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  protected async fetchApiData(props: IProps) {
    this.initCorrelationId();
    this.setState({
      dataLevel: "",
    });
    this.setDataStatus("ready");
    const filtersConverted = ConvertFilter(props.filters);
    const compatible = areFiltersCompatible(filtersConverted);
    if(compatible && !compatible.valid) {
      this.setDataStatus("incompatible-filters-error");
      this.setStatusText(compatible.attribute);
      return;
    }

    const filters = BuildSalesCreditFilters(filtersConverted);
    const profieldictionary = new SCProfileDictionary();
    const builtFilters = GenericFilterBuilder(filters);
    if (filtersConverted.Date) {
      this.setState({ toDate: filtersConverted.Date[0].slice(0, 10) });
    }
    const filterClientsSelected = find(filters, {
      attribute: "clientgen_id",
    });
    const clientsCount = filterClientsSelected
      ? filterClientsSelected.value.split("+").length
      : 0;
    if (filterClientsSelected && clientsCount >= maxSelectedClients) {
      this.setDataStatus("too-many-clients");
      return;
    }
    this.setState((prevState: IState, _: IProps) => ({
      filters: prevState.excludeZero ? builtFilters + scnotzero : builtFilters,
    }));
    this.setState({
      attrsSelected: this.attributes
        .map(x => x.field)
        .sort()
        .join(","),
    });
    this.setState({
      kpisSelected: this.kpis
        .map(x => profieldictionary.GetKpi("MANAGER_SALES_LIST", x.field))
        .sort()
        .join(","),
    });
    this.setState({ visibleAttributes: this.attributes });
    this.setState({ visibleKpis: this.kpis });

    if (props.filters.columns && props.filters.columns.length > 0) {
      const columnsSelected = props.filters.columns;
      this.setState({
        visibleAttributes: this.attributes.filter(
          x => columnsSelected.indexOf(x.headerName) > -1
        ),
      });
      this.setState({
        visibleKpis: this.kpis.filter(
          x => columnsSelected.indexOf(x.headerName) > -1
        ),
      });
      this.setState((prevState: IState, _: IProps) => ({
        attrsSelected: prevState.visibleAttributes
          .map(x => x.field)
          .sort()
          .join(","),
      }));
      this.setState((prevState: IState, _: IProps) => ({
        kpisSelected: prevState.visibleKpis
          .map(x => profieldictionary.GetKpi("MANAGER_SALES_LIST", x.field))
          .sort()
          .join(","),
      }));
    }
    this.setState({ sort: "-" + SCKpis.SC_SC });
    this.setDateOnLevel();
  }

  protected shouldFetchApiData(nextProps: IProps): boolean {
    return true;
  }

  private setDateOnLevel() {
    switch (this.state.level) {
      case SCKpis.SC_YTD: {
        this.setState({
          date: this.state.toDate.slice(0, 4) + "-01-01:" + this.state.toDate,
        });
        break;
      }
      case SCKpis.SC_MTD: {
        this.setState({
          date: this.state.toDate.slice(0, 7) + "-01:" + this.state.toDate,
        });
        break;
      }
      case "specific": {
        this.setState({
          date: this.state.specificFromDate.concat(
            ":",
            this.state.specificToDate
          ),
        });
        break;
      }
      case SCKpis.SC_D_1: {
        const prevDate = new Date(
          new Date(this.state.toDate).setDate(
            new Date(this.state.toDate).getDate() - 1
          )
        )
          .toISOString()
          .slice(0, 10);
        this.setState({
          date: `${prevDate}:${this.state.toDate}`,
        });
        break;
      }
    }
  }

  private onClickExcludeZero() {
    if (this.state.filters.indexOf(scnotzero) > -1) {
      this.setState({
        filters: this.state.filters.replace(scnotzero, ""),
      });
    } else {
      this.setState({
        filters: this.state.filters + scnotzero,
      });
    }
    this.setState({
      excludeZero: !this.state.excludeZero,
    });
    this.saveUserPreference();
  }

  private readonly onChangeFromDate = (value: any) => {
    this.timePeriodClicked("specific");
    this.setState({ specificFromDate: value });
    this.setDateOnLevel();
  };
  private readonly onChangeToDate = (value: any) => {
    this.timePeriodClicked("specific");
    this.setState({ specificToDate: value });
    this.setDateOnLevel();
  };

  private async downloadCsv() {
    this.initCorrelationId();
    this.setState({ spinnerClass: "fa fa-spinner fa-spin" });
    // we must have Sc_sc selected
    if (this.state.kpisSelected.indexOf(SCKpis.SC_SC) < 0) {
      if (
        this.state.kpisSelected === undefined ||
        this.state.kpisSelected == null ||
        this.state.kpisSelected === ""
      ) {
        this.setState({ kpisSelected: SCKpis.SC_SC });
      } else {
        this.setState({
          kpisSelected: SCKpis.SC_SC + "," + this.state.kpisSelected,
        });
      }
    }
    const genericRequest: IGenericRequest = {
      aggregationAttributes: this.state.attrsSelected,
      date: this.state.date,
      filter: this.state.filters,
      kpis: this.state.kpisSelected,
      sort: this.state.sort,
      topN: this.state.top,
    };
    const genericColumnsList: IGenericColumns[] = [];
    for (const element of this.state.visibleAttributes) {
      genericColumnsList.push({
        decimal: 0,
        divisor: 0,
        header: element.headerName,
        id: element.field,
      });
    }
    for (const element of this.state.visibleKpis) {
      genericColumnsList.push({
        decimal: 1,
        divisor:
          [
            SCKpis.SC_SC,
            SCKpis.SC_USD,
            SCKpis.SC_CVA_FEE_EURO,
            SCKpis.SC_F2Y_EURO,
            SCKpis.SC_MARKUP_EURO,
            SCKpis.SC_NOMINAL_YTD_EURO,
            SCKpis.SC_YOY_PER,
          ].indexOf(element.field) > -1
            ? 0
            : 1000,
        header: element.headerName,
        id: element.field,
      });
    }

    const genericCsvRequest: IGenericCsvRequest = {
      genericAggregateDto: genericRequest,
      columns: genericColumnsList,
    };
    try {
      const responseData = await MakeBackgroundExportDataApiCall(
        this.props.headers,
        "sc",
        genericCsvRequest,
        "DealList.xlsx",
        this.props.widgetConfiguration,
        this.state.correlationId
      );
      const errorStatus = HandleCsvCallErrors(responseData);
      if (errorStatus) {
        this.setState({
          dataLevel: errorStatus,
          statusText: responseData.statusText,
        });
      }
      this.setState({ spinnerClass: "" });
    } catch (e) {
      this.setState({
        dataLevel: "server-error",
        spinnerClass: "",
      });
    }
  }

  private timePeriodClicked(newLevel: string) {
    this.setState({ level: newLevel });
    this.fetchApiData(this.props);
    this.saveUserPreference();
  }

  private rowNbrClicked(newTop?: number) {
    this.setState({ top: newTop });
    this.fetchApiData(this.props);
    this.saveUserPreference();
  }

  private saveUserPreference() {
    const dataSotored = {
      excludeZero: this.state.excludeZero,
      level: this.state.level,
      top: this.state.top,
    } as IStoredData;
    localStorage.removeItem(this.key);
    localStorage.setItem(this.key, JSON.stringify(dataSotored));
  }
}

export const SalesCreditExportDealList = withWidgetConfiguration(
  SalesCreditExportDealListClass
);
